import { useCommonContext } from "@/utils/context/common";
import { pxtorem } from "@/utils/pxtorem";
import useNavigation from "@/utils/useNavigate";
import { useUnmount } from "ahooks";
import { Badge } from "antd-mobile";
import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.less";

interface TopNavBarProps {
  onShareClick?: () => void;
  onCartClick?: () => boolean | void;
  onSearchClick?: () => boolean | void;
}

const TopNavBar: React.FC<TopNavBarProps> = ({ onShareClick, onCartClick, onSearchClick }) => {
  const { navigate2Home, navigate2Cart, navigate } = useNavigation();
  const { cartNum, currentRole, track } = useCommonContext();
  const timerRef = useRef<number | null>(null);
  const [showBackButton, setShowBackButton] = useState(false);

  useEffect(() => {
    if (history.length > 1) {
      setShowBackButton(true);
    }
  }, []);

  useUnmount(() => {
    if (timerRef.current !== null) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  });

  const handleBackClick = () => {
    try {
      if (history.length > 1) {
        const url = location.href;
        history.back();

        if (timerRef.current !== null) {
          window.clearTimeout(timerRef.current);
        }

        timerRef.current = window.setTimeout(() => {
          if (location.href === url) {
            navigate2Home();
          }
          timerRef.current = null;
        }, 500);
      } else {
        navigate2Home();
      }
    } catch (error) {
      console.error("返回操作失败:", error);
      navigate2Home();
    }
  };

  const handleHomeClick = () => {
    navigate2Home();
  };

  const handleCartClick = () => {
    const result = onCartClick?.();
    if (result === false) {
      return;
    }
    navigate2Cart();
  };

  const handleSearchClick = () => {
    const result = onSearchClick?.();
    if (result === false) {
      return;
    }
    let url = "/#/mixSearch";
    navigate({
      h5Options: {
        url,
      },
    });
    console.log("Search clicked");
  };

  const handleShareClick = () => {
    console.log("Share clicked");
    onShareClick?.();
  };

  return (
    <div className={styles.topNavBar}>
      {/* 左侧 */}
      <div className={styles.left}>
        {/* 返回按钮 - 条件渲染 */}
        {showBackButton && (
          <>
            <img
              className={styles.back}
              src="https://akim-oss.aikucun.com/f1b739aab1d8afaf3cf03b6e5edf883ae10b3eac_1749718731428_34.png"
              alt="返回"
              onClick={handleBackClick}
            />
            <div className={styles.divider}></div>
          </>
        )}
        {/* 首页 */}
        <div className={styles.home} onClick={handleHomeClick}>
          <img
            src="https://akim-oss.aikucun.com/b633853dfcdaf4f7c4c45711035e5012afa449f9_1749718718546_73.png"
            alt=""
            className={styles.homeIcon}
          />
          <span className={styles.homeText}>首页</span>
        </div>
      </div>
      {/* 右侧 */}
      <div className={styles.right}>
        {/* 搜索 */}
        <img
          className={styles.search}
          src="https://akim-oss.aikucun.com/6f3c2ddd5945a2b570b763fc6f0238b0a3d266d5_1749718718567_55.png"
          alt=""
          onClick={handleSearchClick}
        />
        {/* 分享 */}
        {onShareClick && currentRole === "C" && (
          <img
            className={styles.share}
            src="https://akim-oss.aikucun.com/0e935ca3dad9f870d44cdf3fbb757f9730483937_1749718718560_83.png"
            alt=""
            onClick={handleShareClick}
          />
        )}
        {/* 购物车 */}
        <div onClick={handleCartClick} style={{ display: "flex", alignItems: "center" }}>
          <Badge
            content={cartNum && cartNum > 0 ? String(cartNum) : null}
            style={{ "--right": pxtorem(10), "--top": pxtorem(6) }}>
            <img
              className={styles.cart}
              src="https://akim-oss.aikucun.com/f2cae6729317435afd80f30a52692cc045d79a26_1749718718562_36.png"
              alt=""
            />
          </Badge>
        </div>
      </div>
    </div>
  );
};

export default TopNavBar;
